export default __webpack_public_path__ + "static/media/doctor-confirmation.a69528b8.png";